export default __webpack_public_path__ + "static/media/new_membres.123dee76.jpg";